import React from 'react'
import { Image } from '@shared/components/image'
import styled, { CSSObject } from 'styled-components'

const Card = styled.div(
	() =>
		({
			boxShadow:
				'0px 18px 65px rgba(0, 0, 0, 0.07), 0px 4.02054px 6.37957px rgba(0, 0, 0, 0.0287811), 0px 1.19702px 0px rgba(0, 0, 0, 0.0082118)',
			borderRadius: 16,
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			textAlign: 'center',
			margin: '0 auto',
			padding: 32,
			'@media(min-width: 600px)': {
				width: 569,
				padding: 40,
			},
		} as CSSObject)
)

const Icon = styled(Image)(() => ({
	width: 80,
	height: 80,
	marginBottom: 24,
	'@media(min-width: 600px)': {
		width: 160,
		height: 160,
	},
}))

const Title = styled.h2(({ theme }) => ({
	...theme.typography.header24_32,
	marginBottom: 16,
	'@media(min-width: 600px)': {
		...theme.typography.header30_36,
	},
}))

const Text = styled.p(({ theme }) => ({
	...theme.typography.text16_22,
	'@media(min-width: 600px)': {
		...theme.typography.text20_28,
	},
}))

export const View = () => {
	return (
		<Card>
			<Icon name='success-form-icon' />
			<Title>Согласия получены</Title>
			<Text>Решение по кредиту скоро будет готово</Text>
		</Card>
	)
}
